import { render, staticRenderFns } from "./KpiBadge.vue?vue&type=template&id=0fb44ef6&scoped=true"
import script from "./KpiBadge.vue?vue&type=script&lang=js"
export * from "./KpiBadge.vue?vue&type=script&lang=js"
import style0 from "./KpiBadge.vue?vue&type=style&index=0&id=0fb44ef6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb44ef6",
  null
  
)

export default component.exports